import { render, staticRenderFns } from "./chatCardList.vue?vue&type=template&id=3d412ccd&scoped=true&"
import script from "./chatCardList.vue?vue&type=script&lang=js&"
export * from "./chatCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d412ccd",
  null
  
)

export default component.exports